import moment from 'moment';
import { DISPLAY_DATE_FORMAT, DISPLAY_TIME_FORMAT } from '../config/helpers';

/**
 * Formats a date and time string according to predefined formats.
 * This function assumes that the backend supplies dates in 'YYYY-MM-DD'
 * format and times in 'HH:mm:ss' format. These formats are not ISO compliant
 * as we work on UK time only, but are explicitly defined for application-specific consistency.
 *
 * @param {string} date - The date string in 'YYYY-MM-DD' format.
 * @param {string | undefined } time - The time string in 'HH:mm:ss' format. This parameter is optional.
 * @returns {string} The formatted date and time string or an error message if inputs are invalid.
 */
const formatDateAndTime = (date, time) => {
  const dateTimeFormat = `${DISPLAY_DATE_FORMAT}, ${DISPLAY_TIME_FORMAT}`;
  const inputDateFormat = 'YYYY-MM-DD';
  const inputTimeFormat = 'HH:mm:ss';

  const dateMoment = moment(date, inputDateFormat);
  const timeMoment = moment(time, inputTimeFormat);

  if (!dateMoment.isValid()) return 'Invalid date';
  if (!timeMoment.isValid() && time) return 'Invalid time';

  if (!time) return dateMoment.format(DISPLAY_DATE_FORMAT);

  if (dateMoment.isValid() && timeMoment.isValid()) {
    // Use the parsed hour and minutes to set time on the date object
    dateMoment.set({
      hour: timeMoment.hour(),
      minute: timeMoment.minute(),
    });
    return dateMoment.format(dateTimeFormat);
  }

  return 'Invalid date and time input';
};

export default formatDateAndTime;
